import type {
  ConnectionTestResult,
  RechargeRegisteredWebhooks,
  RechargeRegisterWebhooksResult,
  RechargeSettingsSummary,
  RechargeSettingsUpdateBody,
} from '@flux/shared';
import { apiFetch } from '@/lib/api/client.js';

/**
 * Couche réseau de l'onglet Paramètres → Recharge (`06` §7, §1.3, §8.6).
 * Les secrets ne reviennent jamais : seulement leur présence (`*Configured`).
 */

export function fetchRechargeSettings(): Promise<RechargeSettingsSummary> {
  return apiFetch<RechargeSettingsSummary>('/api/recharge/settings');
}

/** Mise à jour partielle : chaque carte n'envoie que sa section. */
export function updateRechargeSettings(body: RechargeSettingsUpdateBody): Promise<RechargeSettingsSummary> {
  return apiFetch<RechargeSettingsSummary>('/api/recharge/settings', { method: 'PUT', body });
}

export function testRechargeConnection(): Promise<ConnectionTestResult> {
  return apiFetch<ConnectionTestResult>('/api/recharge/settings/test-connection', { method: 'POST' });
}

export function testRechargeSlack(): Promise<ConnectionTestResult> {
  return apiFetch<ConnectionTestResult>('/api/recharge/settings/test-slack', { method: 'POST' });
}

export function fetchRechargeWebhooks(): Promise<RechargeRegisteredWebhooks> {
  return apiFetch<RechargeRegisteredWebhooks>('/api/recharge/webhooks');
}

export function registerMissingRechargeWebhooks(): Promise<RechargeRegisterWebhooksResult> {
  return apiFetch<RechargeRegisterWebhooksResult>('/api/recharge/webhooks/register-missing', { method: 'POST' });
}

export function deleteRechargeWebhook(id: number): Promise<RechargeRegisteredWebhooks> {
  return apiFetch<RechargeRegisteredWebhooks>(`/api/recharge/webhooks/${String(id)}`, { method: 'DELETE' });
}
